import { Link } from 'react-router-dom';
import { company } from '@/mocks/company';

const ctaImg = '/assets/klob-cta-01.jpg';

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={ctaImg} alt="Spachtelmasse auf einer Kelle" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-background-50/80"></div>
        <div className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-primary-500/15 blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 py-24 lg:py-32 text-center">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-background-50/30 px-4 py-1.5 text-[12px] uppercase tracking-[0.2em] text-primary-300 backdrop-blur">
          Ihr Projekt
        </span>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-tight tracking-tight text-foreground-50">
          Sie planen ein Bau- oder<br /><span className="text-primary-500">Ausbauprojekt?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg sm:text-xl text-foreground-100/80">
          Sprechen Sie mit uns über Ihr Vorhaben — wir beraten Sie gerne, unverbindlich und ohne Umschweife.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center h-12 px-9 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold cursor-pointer whitespace-nowrap transition-colors"
          >
            Jetzt Projekt anfragen
          </Link>
          <a
            href={company.phoneHref}
            className="inline-flex items-center justify-center h-12 px-9 rounded-md border border-foreground-50/30 bg-transparent hover:bg-foreground-50/10 text-foreground-50 font-semibold cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-phone-line mr-2"></i>Direkt anrufen
          </a>
        </div>
      </div>
    </section>
  );
}